import React, { FunctionComponent, useMemo } from "react";
import { Theme, makeStyles, Typography, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  selected: {
    fontWeight: 600,
    textDecorationColor: theme.palette.primary.main,
    textDecoration: "underline",
    textDecorationThickness: theme.spacing(0.5),
  },
  unselected: {
    fontWeight: 400,
    color: theme.palette.grey[500],
  },
  item: {
    cursor: "pointer",
  },
}));

interface ILoginSectionButtonProps {
  selected: boolean;
  onClick: () => void;
}

export const LoginSectionButton: FunctionComponent<ILoginSectionButtonProps> = (props) => {
  const { onClick, selected, children } = props;
  const classes = useStyles();

  const className = useMemo(
    () => (selected ? `${classes.item} ${classes.selected}` : `${classes.item} ${classes.unselected}`),
    [selected, classes],
  );

  return (
    <Grid container justify="center">
      <Typography align="center" className={className} onClick={onClick}>
        {children}
      </Typography>
    </Grid>
  );
};
